module.exports = __webpack_public_path__ + "static/img/logo1.648baee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo1.png
// module id = o/JQ
// module chunks = 1